export default `
  query accountDeletionRequest {
    accountDeletionRequest {
      requestedAt
    }
  }
`
